export default function formatCurrency(v) {
  if (!Number.isFinite(v)) return null;
  return (v / 100).toFixed(2);
}
